import axios, { AxiosResponse } from "axios";
import ConnectionClient from "../../shared/api-client";
import cities from "../../assets/json/cities.json";
import { Entity, PageSetting, Query, SortMode } from "../../interfaces";

export const getActorTypes = async () => {
  const actorTypes = await axios.get(
    `${process.env.REACT_APP_API_HOST}/items/actorTypes?fields=*.*`
  );
  return actorTypes.data.data;
};

export const getDependencies = async (userId: string) => {
  const result = await axios.get(
    `${process.env.REACT_APP_API_HOST}/entities/initial-data?page=1&limit=500&fields=*.*.*&collection=all&deep=true`
  );
  return result?.data?.data || null;
};

export const getCities = () => {
  return cities;
};

export const Update = async (id: string, entity: Entity) => {
  const client = new ConnectionClient();
  const result = await client.api.patch(
    `${process.env.REACT_APP_API_HOST}/items/entities/${id}`,
    entity
  );
  return result.data;
};

export const getUniversities = async (actorId: string) => {
  const universities = await axios.get(
    `${process.env.REACT_APP_API_HOST}/items/universities?filter[actor_type][id][_eq]=${actorId}&fields=*.*`
  );
  return universities.data.data;
};
export const getSearcherByUniversity = async (universityId: string) => {
  const universities = await axios.get(
    `${process.env.REACT_APP_API_HOST}/items/universities_searchers?filter[universities_id][id][_eq]=${universityId}&fields=*.*`
  );
  return universities.data.data;
};

export const getSearchersAndUniversities = async (searchId: string) => {
  const universities = await axios.get(
    `${process.env.REACT_APP_API_HOST}/items/universities_searchers?filter[searchers_id][id][_eq]=${searchId}&fields=*.*.*.*`
  );
  return universities.data.data;
};

export const getSearcherById = async (searcherId: string) => {
  const searcher = await axios.get(
    `${process.env.REACT_APP_API_HOST}/items/searchers?filter[id][_eq]=${searcherId}&fields=*.*.*`
  );
  return searcher?.data?.data[0];
};

export const getSearcherByIdEntity = async (entityId: string) => {
  const searcher = await axios.get(
    `${process.env.REACT_APP_API_HOST}/items/searchers_entities?filter[entities_id][_eq]=${entityId}&fields=*.*.*`
  );
  return searcher?.data?.data;
};

export const getSearchers = async (actorId: string) => {
  const searcher = await axios.get(
    `${process.env.REACT_APP_API_HOST}/items/searchers?filter[actor_type][id][_eq]=${actorId}`
  );
  return searcher.data.data;
};

export const getGroups = async (entity: any) => {
  const groups = await axios.get(
    `${process.env.REACT_APP_API_HOST}/items/groups_universities?filter[universities_id][institution_code][_eq]=${entity.institution_code}&fields=*.*.*`
  );
  return groups.data.data;
};

export const getGroupsByUniversityId = async (universityId: any) => {
  const groups = await axios.get(
    `${process.env.REACT_APP_API_HOST}/items/groups_universities?filter[universities_id][_id][_eq]=${universityId}&fields=*.*.*`
  );
  return groups.data.data;
};

export const Remove = async (id: string) => {
  const client = new ConnectionClient();
  const result = await client.api.delete(
    `${process.env.REACT_APP_API_HOST}/items/entity/${id}`
  );
  return result.data;
};

export const getById = async (entity: any) => {
  const groups = await axios.get(
    `${process.env.REACT_APP_API_HOST}/items/groups/${entity}?fields=*.*.*.*`
  );
  return groups.data.data;
};

export const getEntitiesById = async (entity: any) => {
  const groups = await axios.get(
    `${process.env.REACT_APP_API_HOST}/items/universities_entities?filter[universities_id][id][_eq]=${entity}&fields=*.*`
  );
  return groups.data.data;
};

export const getSearcherByEntityId = async (entity: any) => {
  const searchers = await axios.get(
    `${process.env.REACT_APP_API_HOST}/items/universities_searchers?filter[universities_id][id][_eq]=${entity}&fields=*.*`
  );
  return searchers.data.data;
};

export const getEntity = async (entity: any, entityType: string) => {
  const response = await axios.get(
    `${process.env.REACT_APP_API_HOST}/items/${entityType}/${entity}?fields=*.*.*.*`
  );
  return response.data.data;
};

export const getGroup = async (entity: any, entityType: string) => {
  const groups = await axios.get(
    `${process.env.REACT_APP_API_HOST}/items/${entityType}/${entity}?fields=*.*.*`
  );
  return groups.data.data;
};

export const getGroupsUniversities = async (group: any) => {
  const groups = await axios.get(
    `${process.env.REACT_APP_API_HOST}/items/groups_universities?filter[groups_id][_eq]=${group.id}&fields=*.*.*`
  );
  return groups.data.data;
};

export const getCIIU = async (entityId: string) => {
  const response = await axios.get(
    `${process.env.REACT_APP_API_HOST}/items/entities_comercial_activity?filter[entities_id][id][_eq]=${entityId}&fields=*.*`
  );
  return response.data.data;
};

export const Find = async (
  collection: string,
  query: Query,
  page: number = PageSetting.page,
  limit: number = PageSetting.limit
) => {
  const { REACT_APP_API_HOST } = process.env;

  if (!REACT_APP_API_HOST) {
    throw new Error("API host is not configured.");
  }

  const metadata = `?meta=${
    query.meta ? query.meta : `total_count&page=${page}&limit=${limit}`
  }`;
  const fields = "&fields=*.*.*";
  const filter = query.filter
    ? `&${Object.entries(query.filter)
        .map(([key, value]) => `filter[${key}][_eq]=${value}`)
        .join("&")}`
    : "";
  const sort = query.sort
    ? `&sort=${query.sort
        .map(({ field, mode }) => (mode === SortMode.DES ? `-${field}` : field))
        .join(",")}`
    : "";
  const uri = `${REACT_APP_API_HOST}/items/${collection}${metadata}${fields}${filter}${sort}&search=${
    query.search || ""
  }`;

  try {
    const response: AxiosResponse = await axios.get(uri);
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw new Error("Failed to fetch data.");
  }
};

export const getData = async (collection: string, query: Query) => {
  let q = null;
  if (!query.filter) {
    q = `${process.env.REACT_APP_API_HOST}/items/${collection}?meta=total_count&fields=*.*&page=1&limit=10&fields=*.*.*&deep=true`;
  } else {
    q = `${
      process.env.REACT_APP_API_HOST
    }/items/${collection}?meta=total_count&page=${
      query.paginate?.page || 1
    }&limit=${query.paginate?.limit || 10}&${Object.values(query.filter)
      .join("")
      .replace("where", "filter")}&fields=*.*.*&deep=true`;
  }
  const response = await axios.get(q);
  return response.data;
};

export const getAllCIIU = async () => {
  const groups = await axios.get(
    `${process.env.REACT_APP_API_HOST}/items/comercial_activity`
  );
  return groups.data.data;
};

export const getKnowledgeArea = async () => {
  const nowledgeAreas = await axios.get(
    `${process.env.REACT_APP_API_HOST}/items/AREA_DE_CONOCIMIENTO`
  );
  return nowledgeAreas.data.data;
};

export const getknowledgeSpecialty = async () => {
  const nowledgeAreas = await axios.get(
    `${process.env.REACT_APP_API_HOST}/items/ESPECIALIDAD_DE_CONOCIMIENTO`
  );
  return nowledgeAreas.data.data;
};

export const getknowledgeGran = async () => {
  const nowledgeGran = await axios.get(
    `${process.env.REACT_APP_API_HOST}/items/GRAN_AREA_DE_CONOCIMIENTO`
  );
  return nowledgeGran.data.data;
};

export const queryEntities = async () => {
  const result = await axios.get(
    `${process.env.REACT_APP_API_HOST}/items/GRAN_AREA_DE_CONOCIMIENTO`
  );
  return result.data.data;
};

export const getInitialDataEntities = async (
  collection: string,
  query: Query,
  page: number = 1,
  limit: number = 10,
  user?: any
) => {
  let result: any = [];
  if (user) {
    const client = new ConnectionClient();
    result = await client.api.get(
      `${
        process.env.REACT_APP_API_HOST
      }/entities/initial-data?page=${page}&limit=${limit}&${Object.values(
        query.filter
      ).join("")}&fields=*.*.*&deep=true${
        collection ? `&collection=${collection}` : ""
      }`
    );
    return {
      items: result?.data?.data || [],
      meta: result?.data?.meta,
    };
  } else {
    result = await axios.get(
      `${
        process.env.REACT_APP_API_HOST
      }/entities/initial-data?page=${page}&limit=${limit}&${Object.values(
        query.filter
      ).join("")}&fields=*.*.*&deep=true${
        collection ? `&collection=${collection}` : ""
      }`
    );
    return {
      items: result?.data?.data || [],
      meta: result?.data?.meta,
    };
  }
};

export const getEntities = async () => {
  const client = new ConnectionClient();
  const result = await client.api.get(
    `${process.env.REACT_APP_API_HOST}/items/entities?filter&fields=*.*`
  );
  return result?.data || [];
};

export const createEntity = async (data: any) => {
  const client = new ConnectionClient();
  const result = await client.api.post(
    `${process.env.REACT_APP_API_HOST}/items/entities`,
    data
  );
  return result.data.data;
};

export const recomendations = async (
  collection: string,
  query: Query,
  page: number = 1,
  limit: number = 10
) => {
  const client = new ConnectionClient();
  const result = await client.api.get(
    `${
      process.env.REACT_APP_API_HOST
    }/entities/recomendations?page=${page}&limit=${limit}&${Object.values(
      query.filter
    ).join("")}&fields=*.*.*&deep=true${
      collection ? `&collection=${collection}` : ""
    }`
  );
  return {
    items: result?.data?.data || [],
    meta: result?.data?.meta,
  };
};

export const FindById = async (id: string, populate: string) => {
  const client = new ConnectionClient();
  const result = await client.api.get(
    `${process.env.REACT_APP_API_HOST}/items/entities/${id}${
      populate ? `?${populate}` : ""
    }`
  );
  return result.data;
};
